<template>
  <div class="index" style="display: flex;flex-direction: column;min-height: 100vh;">
      <indexHeader></indexHeader>
      <div class="w1200" style="flex:1">
           <div class="title">{{infor.title}}</div>
            <div class="wzcon" v-html="infor.content">
                
             </div>       
      </div>
      <IndexFooter></IndexFooter>
  </div>
</template>

<script>
import indexHeader from '../components/common/indexHeader.vue';
import IndexFooter from '../components/common/indexFooter.vue';
import { pageinfo } from "@/api/index.js"
export default {
    components:{indexHeader,IndexFooter},
  data() {
    return {
      infor:{
        title:'',
        content:''
      }
    }
  },
  mounted() {
   pageinfo({id:this.$route.query.id}).then(res=>{
      if(res.code==1){
        this.infor=res.data
        console.log(this.infor)
      }
   })
  },
  methods:{
  }
}
</script>

<style scoped lang="less">
.index {
  .title {text-align: center;font-size: 35px;border-bottom:1px solid #979797;padding-bottom: 30px;margin-top:30px;margin-bottom:30px;}
.wzcon {font-size:16px;line-height: 35px;}

}
</style>
